import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import ReportStore from '../../stores/ReportStore';

class PrintReportKKCBalance extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{incomeList:[]},itemPerPage:20,allData:[]}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
  }

  loadData(itemPerPage) {
    let {data} = this.state
    let {year,month,cat,q} = this.props
    ReportStore.loadBalanceList(year,month,cat,q,(result)=>{
      let allData = []
      let data = {incomeList:[]}
      data.incomeList = result.data
      allData = this.getPagination(data,itemPerPage)
      this.setState({data:data,allData:allData})
    })
  }

  getAll() {
    let {data} = this.state
    return data.incomeList.length
  }

  getSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status>='2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getNotSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status<'2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getSummaryPercent(key) {
    let sum = 0
    let confirm_price = this.getSummary('confirm_price')
    let expense_amount = this.getSummary('expense_amount')
    let sum_exp = this.getSummaryExpense()
    if (key==='exp') {
      sum = (sum_exp*100)/confirm_price
    } else if (key==='balance') {
      sum = (expense_amount*100)/confirm_price
    }
    
    if (isNaN(sum)) {
      return 0
    } else {
      return sum.toFixed(2)
    }
  }

  getSummaryExpense() {
    let sum = 0
    sum = parseFloat(this.getSummary('expense_office'))+parseFloat(this.getSummary('expense_mechanic'))+parseFloat(this.getSummary('expense_stock'))
    return sum
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      let val = item[key] 
      if (val===''||val===null||val===undefined||isNaN(val)) {
        val = 0
      }
      sum = parseFloat(val) + parseFloat(sum)
    })
    return sum
  }

  getSummaryConfirmCash() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.insurer_id==='0'||item.insurer_id===0||item.insurer_id==='') {
        let val = item.final_price
        if (val===''||val===null||val===undefined||isNaN(val)) {
          val = 0
        }
        sum = parseFloat(val) + parseFloat(sum)
      }  
    })
    return sum
  }

  getRowTextColor(insurer_id) {
    if (insurer_id==='0'||insurer_id===0||insurer_id==='') {
      return 'color-blue'
    } else {
      return 'color-red'
    }
  }

  getNumberFormat(val) {
    if (val!==''&&val!==undefined&&val!==null&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    }
    return val
  }

  renderBody(items,page=0) {
    if (items.data.length===0||items.data===undefined) {
      return(<tr><td colSpan={20}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.data.map((item,index)=> {
          let number = 0
          if (page===0) {
            number = parseInt(index)+parseInt(1)
          } else {
            number = parseInt((page*this.state.itemPerPage)) + parseInt(index)+parseInt(1)
          }
          return(
            <tr key={index}>
              <td className='text-center'>{number}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className={this.getRowTextColor(item.insurer_id)}>{item.owner_name}</td>
              <td className={this.getRowTextColor(item.insurer_id)}>{item.paid_by}</td>
              <td className={this.getRowTextColor(item.insurer_id)}>{item.car_detail}</td>
              <td className='text-center'>{item.entrance_date}</td>
              <td className='text-center color-red'>{item.appointment_date}</td>
              <td className='text-center color-blue bg-4'>{item.delivering_date}</td>
              <td className='text-right bg-5'>{this.getNumberFormat(item.auction_price)}</td>
              <td className='text-right color-blue bg-2'>{this.getNumberFormat(item.confirm_price)}</td>
              <td className='text-right color-red'>{this.getNumberFormat(item.expense_office)}</td>
              <td className='text-right color-red'>{this.getNumberFormat(item.expense_mechanic)}</td>
              <td className='text-right color-red'>{this.getNumberFormat(item.expense_stock)}</td>
              <td className='text-right bg-2'>{this.getNumberFormat(item.expense_amount)}</td>
            </tr>
          )
        })  
      )
    }
  }

  renderSignature() {
    return(
          <div className='footer-page-landscape'>
            <div>
              <table className='table table-signature-print-report-kkc-income'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>(ผู้จัดทำ)</div>
                      <div>(สุวรรณภา ทาสันเทียะ)</div>
                      <div>จัดซื้อ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>(ตรวจสอบ)</div>
                      <div>(สุภาวดี ปราบวงษา)</div>
                      <div>บัญชี / การเงิน</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>(ตรวจสอบ)</div>
                      <div>(สมเดช เรดสันเทียะ)</div>
                      <div>ผู้จัดการ</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table className='table table-signature-print-report-kkc-income'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>(ตรวจสอบ)</div>
                      <div>(นางสาว สุชาดา พงษ์เกาะ)</div>
                      <div>รอง กรรมการผู้จัดการ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>(รับทราบ)</div>
                      <div>(เกษม พงษ์เกาะ)</div>
                      <div>กรรมการผู้จัดการ</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
    )
  }

  renderFooter() {
    return(
          <tfoot>
            <tr>
              <th colSpan={8} className='text-center bg-1'>{'รวมรายการรถเข้าซ่อม '+this.getAll()+' รายการ ซ่อมเสร็จ '+this.getSuccess()+' คัน กำลังซ่อม '+this.getNotSuccess()+' คัน'}</th>
              <th className='text-right bg-6'>{this.getSummary('auction_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-1'>{this.getSummary('confirm_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-1'>{this.getSummary('expense_office').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-1'>{this.getSummary('expense_mechanic').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-5'>{this.getSummary('expense_stock').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_amount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
            </tr>
            <tr>
              <th colSpan={8} className='bg-none'></th>
              <th colSpan={2} className='text-center bg-1'>รวมราคายืนยัน</th>
              <th colSpan={3} className='text-center bg-2'>รวมค่าใช้จ่าย</th>
              <th className='text-center bg-2'>รวมคงเหลือ</th>
            </tr>
            <tr>
              <th colSpan={8} className='bg-none'></th>
              <th colSpan={2} className='text-right bg-1'>{this.getSummary('confirm_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th colSpan={3} className='text-right bg-2'>{this.getSummaryExpense().toLocaleString(undefined, {maximumFractionDigits: 2})+' ('+this.getSummaryPercent('exp')+'%)'}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_amount').toLocaleString(undefined, {maximumFractionDigits: 2})+' ('+this.getSummaryPercent('balance')+'%)'}</th>
            </tr>  
          </tfoot>
    )
  }

  renderTable(items,index) {
    return (
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-income table-print-report-kkc-income'>
          <thead>
            <tr>
              <th className='text-center bg-1' rowSpan={2}>ลำดับ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'150px'}}>ทะเบียนรถ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'150px'}}>เจ้าของรถ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'120px'}}>บริษัทประกัน<br/>เงินสด เครดิต</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'100px'}}>รายการซ่อม ชนิดรถ</th>
              <th className='text-center bg-1' colSpan={3}>วัน-เดือน-ปี</th>
              <th className='text-center bg-2' colSpan={6}>เครดิต / เงินสด / ประกัน</th>
            </tr>
            <tr>
              <th className='text-center bg-1' style={{width:'70px'}}>รับรถ</th>
              <th className='text-center bg-1' style={{width:'70px'}}>กำหนดส่ง</th>
              <th className='text-center bg-1' style={{width:'70px'}}>รถออกจริง</th>
              <th className='text-center bg-4' style={{width:'70px'}}>ราคาประมูลและเงินสด</th>
              <th className='text-center bg-1' style={{width:'70px'}}>ราคายืนยัน</th>
              <th className='text-center bg-1' style={{width:'70px'}}>ค่าแรงธุรการ/ค่าน้ำ/ค่าไฟ</th>
              <th className='text-center bg-1' style={{width:'70px'}}>ค่าแรงช่าง</th>
              <th className='text-center bg-1' style={{width:'70px'}}>ค่าอะไหล่ + วัสดุสิ้นเปลือง</th>
              <th className='text-center bg-4' style={{width:'100px'}}>คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody(items,index)}
          </tbody>
          {items.footer?this.renderFooter():''}
        </table>
        {items.footer?this.renderSignature():''}
      </div>
    )  
  }

  renderComponentPage(items,index) {
    return(
      <div className='font-print' key={index}>
        <header style={{textAlign:'center',marginBottom:'20px'}}>
          <h2>{this.props.title+' '+this.getTextMonth(this.props.month)+' '+this.props.year+' '+this.getSearchOption()}</h2>
        </header>
        <div className='font-14'>   
          {this.renderTable(items,index)}          
        </div>
      </div>  
    )
  }

  getTextMonth(month) {
    let text = ''
    if (month==='00') {
      text = 'ทั้งปี'
    } else if (month==='01'){
      text = 'มกราคม'
    } else if (month==='02'){
      text = 'กุมภาพันธ์'
    } else if (month==='03'){
      text = 'มีนาคม'
    } else if (month==='04'){
      text = 'เมษายน'
    } else if (month==='05'){
      text = 'พฤษภาคม'
    } else if (month==='06'){
      text = 'มิถุนายน'
    } else if (month==='07'){
      text = 'กรกฎาคม'
    } else if (month==='08'){
      text = 'สิงหาคม'
    } else if (month==='09'){
      text = 'กันยายน'
    } else if (month==='10'){
      text = 'ตุลาคม'
    } else if (month==='11'){
      text = 'พฤศจิกายน'
    } else if (month==='12'){
      text = 'ธันวาคม'
    }
    return text
  }

  getSearchOption() {
    if (this.props.cat==='owner_person'||this.props.cat==='owner_company') {
      return 'เจ้าของรถ '+this.props.q===undefined||this.props.q===''?'':this.props.q
    }else if (this.props.cat==='insurer') {
      return 'ประกัน '+this.props.q===undefined||this.props.q===''?'':this.props.q
    } else {
      return ''
    }
  }

  getPagination(data,itemPerPage) {
    let checkRow = 0
    let newData = []
    let allData = []
    let footer = false
    data.incomeList.forEach(function(item,index) {
      if (checkRow<itemPerPage) {
        newData.push(item)
      }
      if (checkRow===itemPerPage-1||index===data.incomeList.length-1) {
        if (index===data.incomeList.length-1)
          footer = true
        allData.push({
          data:newData,
          footer:footer
        })
        newData = []
        checkRow = -1
      }
      checkRow++
    })

    return allData
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  render() {
    let {loading,allData} = this.state

    return(
      <PrintPreview 
        loading={loading} 
        size={'landscape'}
        leftBarTitle={this.props.title+' '+this.getTextMonth(this.props.month)+' '+this.props.year}
        defaultRowPerPage={20}
        startRowPerPage={10}
        endRowPerPage={25}
        onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
      >
        {
          allData.map((item,index) => {
            return(
              this.renderComponentPage(item,index)
            )
          })
        }
      </PrintPreview>
    )
  }

}  

PrintReportKKCBalance.defaultProps = {
  title: 'รายงานสรุปรถออกรายได้คงเหลือ',  
  mode : '1'
}
export default PrintReportKKCBalance;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCBalance.js